export const ERROR = {
    CASE_CANCELLED: 'CASE_CANCELLED',
    FAILED_TO_DELETE_CHAT_MESSAGE_CID: 'FAILED_TO_DELETE_CHAT_MESSAGE_CID',
    DUPLICATE_CASE_SUBMISSION: 'DUPLICATE_CASE_SUBMISSION',
    SELF_DESIGN_CASE: 'SELF_DESIGN_CASE',
};

export const ROLE_NAMES = {
    super_admin: 'SADMIN',
    admin: 'ADMIN',
    distributor: 'DISTR',
    group_admin: 'GADMIN',
    clinic_admin: 'CADMIN',
    doctor: 'DR',
    nurse: 'NR',
};

export const ADMIN_ROLES = [
    ROLE_NAMES.super_admin,
    ROLE_NAMES.admin,
    ROLE_NAMES.distributor,
    ROLE_NAMES.group_admin,
    ROLE_NAMES.clinic_admin,
];

export const PACKAGE_VERSION = {
    Pre2026: 'Pre 2026',
    2026: '2026',
};
